import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { chooseOptionsConstant } from 'src/app/constants/service.constants';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import * as $ from 'jquery';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { INSTRUCTION } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-instructions-modal',
  templateUrl: './instructions-modal.component.html',
  styleUrls: ['./instructions-modal.component.scss']
})
export class InstructionsModalComponent implements OnInit {
  Content: any;
  formFields;
  loiOptions = chooseOptionsConstant;
  instruct: INSTRUCTION[] = []
  heading: string;
  FORMDATA;
  program;
  programdata: any = [];
  action: Subject<any> = new Subject();
  instructionsForm = new UntypedFormGroup({
    ID: new UntypedFormControl(""),
    CODE: new UntypedFormControl(""),
    NAME: new UntypedFormControl(""),
    RECORD_STATE: new UntypedFormControl(true),
    DESCRIPTION: new UntypedFormControl(""),
    MODULE_ID: new UntypedFormControl(""),
    CATEGORY: new UntypedFormControl(""),
    ModuleStr: new UntypedFormControl(""),
    SHOWINSTRUCTIONTOUSER: new UntypedFormControl(false)
  });

  editorInit: Record<string, any> | undefined = {
    base_url: '/tinymce',
    selector: 'editor#bodyeditor',
    suffix: '.min',
    statusbar: false,
    height: '200px !important',
    readonly: 1,
    paste_data_images: true,
    menubar: true,
    toolbar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks fullscreen',
      'insertdatetime media table paste'
    ]
  };

  constructor(
    private summaryService: AdministrationSummaryService,
    public activemodalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private Commonservice: CommonService
  ) {
  }

  ngOnInit() {
    if (this.Content.content && this.Content.content.id) { // Edit mode
      this.summaryService.getSummaryData('api/instruction/getinstructionbyid/' + this.Content.content.id).subscribe((result) => {
       
        this.setForm(result);

        if (this.Content.heading === 'View') {
          setTimeout(() => {
            this.instructionsForm.disable({ emitEvent: false });
          }, 100);
        }
        if(this.Content.heading === 'Edit')
        {
          this.instructionsForm.controls["MODULE_ID"].disable();
        }
      });
    }
    this.programModuleState();
   
   
  }

  private setForm(result: any): void {
    this.instructionsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(result.ID),
      CODE: new UntypedFormControl(result.CODE, [Validators.maxLength(50)]),
      NAME: new UntypedFormControl(result.NAME, [Validators.required, Validators.maxLength(100)]),
      DESCRIPTION: new UntypedFormControl(result.DESCRIPTION, [Validators.required]),
      SCREENTEXT: new UntypedFormControl(result.SCREENTEXT),
      MODULE_ID: new UntypedFormControl(result.ModuleStr),
      RECORD_STATE: new UntypedFormControl(result.RECORD_STATE),
      RecordStatus: new UntypedFormControl(result.RecordStatus),
      ModuleStr: new UntypedFormControl(result.ModuleStr), 
      SHOWINSTRUCTIONTOUSER: new UntypedFormControl(result.SHOWINSTRUCTIONTOUSER)
    });
  }

  save() {

    if (this.validateControls()) {

      const formdata = this.instructionsForm.getRawValue();
      formdata.CATEGORY = this.Content.content.InstructionType;
      formdata.RECORD_STATE = this.instructionsForm.controls["RECORD_STATE"].value ? 1 : 0;
      if (formdata.DESCRIPTION != null && formdata.DESCRIPTION != undefined) {
        formdata.DESCRIPTION = formdata.DESCRIPTION.replaceAll("<a", "<a target='_blank'")
      }

      formdata.NAME = formdata.NAME == null ? null : formdata.NAME == undefined ? undefined : formdata.NAME.trim();
      if (this.Content.heading == "Edit") {
        if (formdata.CATEGORY == "Compliance Statement" || formdata.CATEGORY == "CS") {
          formdata.CATEGORY = "CS";
        }
        else
          formdata.CATEGORY = "USI";
        this.summaryService.Insert('api/instruction/update', formdata).subscribe(result => {
          if (result.Status === 0) {
            this.activemodalRef.close();
            if (formdata.CATEGORY == "USI") {
              this.Commonservice.SuccessBanner('User Instruction ' + "'" + formdata.NAME + "'" + ' updated successfully');
             
            }
            else {
              this.Commonservice.SuccessBanner('Compliance Statement ' + "'" + formdata.NAME + "'" + ' updated successfully');
           
            }
          }
          else {
            this.Commonservice.ValidationBanner(result.Message);
          }
        })
      
      }
      else {
        this.summaryService.Insert('api/instruction/insert', formdata).subscribe(result => {
          if (result.Status === 0) {
            this.activemodalRef.close();
            if (formdata.CATEGORY == "USI") {
              this.Commonservice.SuccessBanner('User Instruction ' + "'" + formdata.NAME + "'" + ' added successfully');
            
            }
            else {
              this.Commonservice.SuccessBanner('Compliance Statement ' + "'" + formdata.NAME + "'" + ' added successfully');
             
            }
          }
          else {
            this.Commonservice.ValidationBanner(result.Message);
          }
        })
      
      }

    }
  }

  programModuleState() {
    this.summaryService.GetData("api/common/getapptypemodules").subscribe((res) => {
      this.programdata = res;
    })
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.instructionsForm.getRawValue();

    if (formData.NAME === null || formData.NAME === "" || formData.NAME === undefined) {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      if(this.Content.content.InstructionType == "USI")
      {
        message += "Please enter User Instructions Name<br/>";
        isValid = false;
      }
      else
      {
        message += "Please enter Compliance Statement Name<br/>";
        isValid = false;
      }
      
    } else if (formData.NAME != null && formData.NAME != undefined && formData.NAME.trim() == "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      if(this.Content.content.InstructionType == "USI")
      {
        message += "Please enter User Instructions Name<br/>";
        isValid = false;
      }
      else
      {
        message += "Please enter Compliance Statement Name<br/>";
        isValid = false;
      }
     
    }
    else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.MODULE_ID === null || formData.MODULE_ID === "") {
      $("#MODULE_ID").addClass("ng-touched ng-invalid validate-error");
      $("#MODULE_ID").removeClass("ng-untouched ng-valid");
      message += "Please select Program<br/>";
      isValid = false;
    } else {
      $("#MODULE_ID").addClass("ng-untouched ng-valid");
      $("#MODULE_ID").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.DESCRIPTION == null || formData.DESCRIPTION == "" || formData.DESCRIPTION == "\n") {
      $("#DESCRIPTION").addClass("ng-touched ng-invalid validate-error");
      $("#DESCRIPTION").removeClass("ng-untouched ng-valid");
      message += "Please enter Description<br/>";
      isValid = false;
    } else {
      $("#DESCRIPTION").addClass("ng-untouched ng-valid");
      $("#DESCRIPTION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      this.Commonservice.ValidationBanner(message);
    return isValid;
  }

}
